import React from 'react'
import { Link as GLink } from 'gatsby'
import { Link, useThemeUI, get } from 'theme-ui'
import rv from '@components/utils/buildResponsiveVariant'
import getImageVariant from '@components/utils/getImageVariant'
import CardMediaIcon from './Card.Media.Icon'
import CardMediaImage from './Card.Media.Image'

const DEFAULT_IMAGE_VARIANT = 'vertical'

const styles = {
  link: {
    userSelect: `none`,
    textAlign: `center`,
    position: `relative`,
    display: `block`
  }
}

const CardMedia = ({
  imageVariant,
  isPartner,
  omitMedia,
  mediaType,
  title,
  slug,
  isHeritage,
  link,
  isTagBlog,
  linkKey,
  isSymposium,
  callFrom,
  button,
  button01,
  ...props
}) => {
  const context = useThemeUI()

  if (omitMedia) return null

  const { variant, featuredImage, thumbnailText } = props

  if (callFrom === 'Event' || 'EventPage') {
    link = ''
  }

  const imageVar =
    imageVariant ||
    get(context.theme, rv(variant, 'imageVariant')[0]) ||
    DEFAULT_IMAGE_VARIANT

  const image =
    getImageVariant(featuredImage, imageVar) ||
    featuredImage[0]?.ImageSharp_vertical.gatsbyImageData ||
    featuredImage?.ImageSharp_vertical.gatsbyImageData

  const linkProps = link
    ? {
        as: 'a',
        href: link,
        target: '_blank',
        rel: 'noopener noreferrer'
      }
    : callFrom === 'symposium' || isHeritage
    ? {
        as: 'a',
        href: button ? button[0].url : button01.url,
        target: '_blank',
        rel: 'noopener noreferrer'
      }
    : {
        as: GLink,
        to: slug
      }
  return !isHeritage ? (
    <Link
      {...linkProps}
      style={
        props.callFrom === 'EventPage'
          ? { alignItems: 'center', display: 'flex' }
          : {}
      }
      css={styles.link}
      sx={{ variant: rv(variant, 'media') }}
      aria-label={title}
    >
      {mediaType === 'image' && image && (
        <CardMediaImage
          image={image}
          title={title}
          {...props}
          isHeritage={isHeritage}
          isSymposium={isSymposium}
        />
      )}
      {(mediaType === 'icon' || (!image && thumbnailText)) && (
        <CardMediaIcon {...props} />
      )}
    </Link>
  ) : (
    <Link
      {...linkProps}
      css={styles.link}
      sx={{ variant: rv(variant, 'media') }}
      aria-label={title}
      style={{ margin: '0px', display: 'flex' }}
    >
      {mediaType === 'image' && image && (
        <CardMediaImage
          image={image}
          title={title}
          {...props}
          isHeritage={isHeritage}
          isSymposium={isSymposium}
        />
      )}
      {(mediaType === 'icon' || (!image && thumbnailText)) && (
        <CardMediaIcon {...props} />
      )}
    </Link>
  )
}

CardMedia.defaultProps = {
  mediaType: 'image'
}

export default CardMedia
